<template>
  <span :class="containerClass">
    <button :class="[buttonClass, { success: copied }]" @click="copyToClipboard"><slot v-if="!copied"></slot> {{ copied ? successMessage : '' }}</button>
    <input type="hidden" :ref="generated" :value="value" />
  </span>
</template>

<script>
export default {
  props: {
    value: {},
    containerClass: {
      default: ''
    },
    buttonClass: {
      default: 'btn_copy'
    },
    successMessage: {
      default: 'Copied!'
    }
  },
  computed: {
    generated() {
      return Math.random().toString(36).substring(7);
    }
  },
  data() {
    return {
      copied: false
    }
  },
  methods: {
    async copyToClipboard() {
      let input = this.$refs[this.generated];

      try {
        await navigator.clipboard.writeText(input.value);
        this.copied = true;

        setTimeout(() => {
          this.copied = false;
        }, 5000);
      } catch (err) {
        console.error('Could not copy text: ', err);
        alert('Oops, unable to copy');
      }
    }
  },
}
</script>
